import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectScreenIdMstModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'screenId',
        'screenName',
        'screenIdStatus',
        'selectButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          screenId: '固定画面ID',
          screenName: '固定画面名',
          screenIdStatus: 'ステータス',
          selectButton: ''
        },
        columnsClasses: {
          screenId: 'wp-5',
          screenName: '',
          screenIdStatus: '',
          selectButton: 'wp-5'
        },
        sortable: [
          'screenId',
          'screenName',
          'screenIdStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('固定画面'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      // model
      screenIdMstModel: state => state.selectScreenIdMstModal.screenIdMstModel,

      // modal setting
      active: state => state.selectScreenIdMstModal.active,
      overlay: state => state.selectScreenIdMstModal.overlay
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectScreenIdMstModal/loadModel',
      hide: 'selectScreenIdMstModal/hide',
      setValue: 'selectScreenIdMstModal/setValue',
      reset: 'selectScreenIdMstModal/reset'
    }),

    init () {
      this.loading = true

      // storeをリセット
      this.reset()

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenIdMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'screenIdStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    selectItem (props) {
      // console.log(props.row)

      // 選択されたファイル情報をstoreに保持
      this.setValue(props.row.screenIdMstUuid)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}